import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=e0425b28&scoped=true&"
import script from "./Archive.vue?vue&type=script&lang=ts&"
export * from "./Archive.vue?vue&type=script&lang=ts&"
import style0 from "./Archive.vue?vue&type=style&index=0&id=e0425b28&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0425b28",
  null
  
)

export default component.exports